/* eslint-disable @typescript-eslint/no-explicit-any */

import { Logger } from '@nestjs/common';

const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

const argToString = (arg) => {
  if (typeof arg === 'undefined') {
    return `undefined`;
  }

  if (typeof arg === 'string') {
    return `'${arg}'`;
  }

  if (typeof arg === 'number') {
    return arg.toString();
  }

  if (arg.constructor.name === 'Object' || arg.constructor.name === 'Array') {
    const jsonString = JSON.stringify(arg, getCircularReplacer());
    return jsonString.length > 500
      ? jsonString.substr(0, 500) + ' ... '
      : jsonString;
  }

  return `<${arg.constructor.name}>`;
};

export function Loggable(
  target: any,
  propertyKey: string,
  descriptor: TypedPropertyDescriptor<any>
): TypedPropertyDescriptor<any> {
  const originalMethod = descriptor.value;

  descriptor.value = function (...args: any[]): any {
    const argsMap: string[] = args.map(argToString);

    const functionNameWithArgs = `[Loggable] ${
      target.constructor.name
    }.${propertyKey}(${argsMap.join(', ')})`;
    Logger.debug(functionNameWithArgs);

    return originalMethod.apply(this, args);
  };

  return descriptor;
}
